import PullRelease from 'shared/components/PullRelease';

const Header = () => {
  return (
    <PullRelease>
      <h1>
        <img className="logo" src="/img/logo-blue.svg" />
        <span>Partner Portal</span>
      </h1>
    </PullRelease>
  )
}

export default Header;
